import React from "react";
import { CheckboxProps } from "interfaces/checkbox.interface";
import { Colors } from "utils/theme.utils";
import "./checkbox.component.scss";

// A checkbox with a label that may contain links. Clicking a link inside the label opens the link and leaves the box alone.
const Checkbox = (props: CheckboxProps): React.ReactElement => {
  const { checked, onChange, label, disabled = false, className, accentColor, textColor } = props;

  return (
    <label
      className={`checkbox${disabled ? " checkbox_disabled" : ""}${className ? ` ${className}` : ""}`}
      style={{ color: textColor ?? Colors.onPrimary }}
    >
      <input
        type="checkbox"
        className="checkbox_input"
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          if (!disabled) onChange(e.target.checked);
        }}
        style={{ accentColor: accentColor ?? Colors.primaryColor }}
      />
      <span className="checkbox_label">{label}</span>
    </label>
  );
};

export default Checkbox;
